import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';
const style = () =>
  createStyles({
    root: {
      cursor: 'pointer',
      height: '100%',
      width: '100%',
      backgroundColor: palette.background.paper,
      borderRadius: palette.borderRadius.default,
      padding: '20px',
      boxSizing: 'border-box',
      position: 'relative',
      overflow: 'hidden',
      '&:after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        background:
          'linear-gradient(98.45deg, rgba(0, 0, 255, 0.698039) 36.91%, rgba(0, 0, 255, 0) 107.15%)',
        width: '100%',
        height: '100%',
        borderRadius: palette.borderRadius.default,
        zIndex: 0,
        boxShadow: palette.shadows.boxInnerShadow
      },
      '& img': {
        height: '100%',
        width: 'auto',
        position: 'absolute',
        top: 0,
        right: 0
      }
    },
    content: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      zIndex: 1,
      color: '#FFFFFF',
      '& svg path': {
        stroke: '#FFFFFF'
      }
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '1.5rem'
    },
    subtitle: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '1rem'
    },
    cta: { display: 'flex', alignItems: 'center', gap: '10px' }
  });
const useStyle = makeStyles(style);
export default useStyle;
